import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { isString } from '@fi-shared/utils/is-string';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { isObject } from '@fi-shared/utils';
import { ActionFailureReasonCode } from '@fi-shared/types/action-failed-reason-code';

const currentRequests: {
    [key: string]: IFiHttpPromise<any>;
} = {};

@Injectable()
export class FiLogErrorService {
    constructor(
        private fiBackend: FiBackendService,
        private userDataService: FiUserDataService,
    ) {}

    logError(exception) {
        if (!exception) return;

        const reason: ActionFailureReasonCode = exception?.error?.Reason;

        // https://chainformation.atlassian.net/browse/FI-6457
        // we can't log frontend error for not founded domain
        if (reason === ActionFailureReasonCode.General_DomainNotFound) return;

        let message: string;
        if (isString(exception)) {
            message = exception;
        } else {
            if (exception.message) {
                message = exception.message;
            } else {
                message = exception.toString();
            }
        }

        let userId = 0;
        try {
            userId = this.userDataService.getUserId();
        } catch {}

        const data = {
            ModuleName: 'Core',
            SeverityLevelType: 3,
            Message: (isObject(message) ? JSON.stringify(message) : message) + '\n' + window.location.href,
            InnerException: exception
                ? JSON.stringify({
                      name: exception.name,
                      stack: exception.stack ? exception.stack.toString() : exception.stack,
                      message: exception.message ? exception.message : exception.toString(),
                      userId: userId,
                      //cause: cause,
                      // exception: exception // got error: TypeError: Converting circular structure to JSON
                  })
                : '',
        };

        const key = JSON.stringify(data);
        if (currentRequests[key]) return true;

        // todo show once on errors in html, use on stateChangeSuccess
        // show in console as error
        console.error(exception);

        if (
            data.Message.indexOf('Uncaught (in promise)') === -1 &&
            data.Message.indexOf('ExpressionChangedAfterItHasBeenCheckedError') === -1
        ) {
            // send to server
            currentRequests[key] = this.fiBackend.fetchDataPost('Core/Authenticate/LogFrontendError', data, {
                supressErrorMessage: true,
            });
            currentRequests[key].finally(function () {
                setTimeout(() => {
                    delete currentRequests[key];
                }, 2000);
            });
        }
    }
}
